module.exports = __webpack_public_path__ + "img/jiandang-cover.563642b0.jpg";